import { createWebHistory, createRouter } from "vue-router";

//import store from '@/state/store'
import routes from './routes'
import appConfig from "../../app.config";

const router = createRouter({
    history: createWebHistory(),
    routes,
    // Use the HTML5 history API (i.e. normal-looking routes)
    // instead of routes with hashes (e.g. example.com/#/about).
    // This may require some server configuration in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    mode: 'history',
    // Simulate native-like scroll behavior when navigating to a new
    // route and using back/forward buttons.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0, left: 0 }
        }
    },
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {

    if(routeTo.fullPath == "/[object%20Object]"){
         next();
    }
    console.log('routeTo', routeTo)
    const publicPages = ['/', '/Redirect','/account/delete','/register', "/admin-setup", '/forgot-password', '/reset-password', '/send-verification', '/verification-success', '/setup-profile', '/setup-success', '/registration-success', '/application-approved', '/application-rejected', '/otp-list', '/privacy-policy', '/product-disclosure', '/terms-condition', '/reset-password-success', '/customer-notice', '/director/verify'];
    const authpage = !publicPages.includes(routeTo.path);
    const loggeduser = localStorage.getItem('accessToken');
    const isBackOfficeRejected = localStorage.getItem('isBackOfficeRejected') ? true : false;
    const isSetupCompleted = localStorage.getItem('isSetupCompleted') ? true : false;

    const isVrified = JSON.parse(localStorage.getItem('isVerifiedUser'))
    if (isBackOfficeRejected && routeTo.path != '/application-rejected') {
        console.log('rejected')
        return next('/application-rejected')
    }
    if (isSetupCompleted && routeTo.path != '/setup-success' && routeTo.path !== '/director/verify') {
        console.log('rejected')
        return next('/setup-success')
    }
    else if (publicPages.includes(routeTo.path) && routeTo.path !== '/director/verify' && loggeduser && isVrified && !isBackOfficeRejected) {
        console.log('changepassword')
        return next('/dashboard')
    }

    else if (authpage && (!loggeduser || !isVrified) && !isBackOfficeRejected) {
        console.log('login')
        return next('/');
    }
    let resolved = router.resolve(routeTo.path);
    if (resolved.matched.length == 0) {
        return next('/dashboard')
    }


    // else if (publicPages && loggeduser && isVrified) {
    //     return next('/register');
    // }
    //check for routes for super admin
    // if(routeTo.meta.isSuperAdmin && (store.state.auth.currentUser != null || store.state.auth.currentUser !='') && isVrified){
    //     if(store.state.auth.currentUser.Role.toLowerCase().replace(/ /g,'')!='corporatesuperadmin')
    //         next('/dashboard');
    //     }
    next();
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
    // Create a `beforeResolve` hook, which fires whenever
    // `beforeRouteEnter` and `beforeRouteUpdate` would. This
    // allows us to ensure data is fetched even when params change,
    // but the resolved route does not. We put it in `meta` to
    // indicate that it's a hook we created, rather than part of
    // Vue Router (yet?).
    try {
        // For each matched route...
        for (const route of routeTo.matched) {
            await new Promise((resolve, reject) => {
                // If a `beforeResolve` hook is defined, call it with
                // the same arguments as the `beforeEnter` hook.
                if (route.meta && route.meta.beforeResolve) {
                    route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
                        // If the user chose to redirect...
                        if (args.length) {
                            // If redirecting to the same route we're coming from...
                            // Complete the redirect.
                            next(...args)
                            reject(new Error('Redirected'))
                        } else {
                            resolve()
                        }
                    })
                } else {
                    // Otherwise, continue resolving the route.
                    resolve()
                }
            })
        }
        // If a `beforeResolve` hook chose to redirect, just return.
    } catch (error) {
        return
    }
    document.title = routeTo.meta.title + ' | ' + appConfig.title;
    // If we reach this point, continue resolving the route.
    next()
})

export default router